export default __webpack_public_path__ + "static/media/eco-score-F.2cb92679.svg";